import { setStore, getStore } from '@/utils/store'
import { companyDetailUrl, companyAccountDetailUrl, individualDetailUrl } from '@/api'
import { get } from '@/utils'
const common = {
  state: {
    currentMenuObj: getStore({ name: 'currentMenuObj' }) || { menus: [] },
    companyDetail: {},
    companyAccountDetail: {},
    individualAccountDetail: {},
    langType: localStorage.getItem('lang') || 's',
    showLoginDialog: false
  },
  actions: {
    // 设置当前左侧菜单
    SetCurrentMenuObj: ({ commit }, menuObj) => {
      commit('SET_CURRENT_MENU_OBJ', menuObj)
    },
    SetCompanyDetail: async ({ commit }, menuObj) => {
      const { data } = await get(companyDetailUrl)
      commit('SET_COMPANY_DETAIL', data)
    },
    SetCompanyAccountDetail: async ({ commit }, menuObj) => {
      const { data } = await get(companyAccountDetailUrl)
      data.avatar.link = data.avatar.link ? data.avatar.link : require('../assets/img/company-avatar.png')
      data.avatar.id = data.avatar.id ? data.avatar.id : ''
      commit('SET_COMPANY_ACCOUNT_DETAIL', data)
    },
    SetIndividualAccountDetail: async ({ commit }, menuObj) => {
      const { data } = await get(individualDetailUrl)
      data.avatar.link = data.avatar.link ? data.avatar.link : require('../assets/img/talent-img.png')
      data.avatar.id = data.avatar.id ? data.avatar.id : ''
      commit('SET_INDIVIDUAL_ACCOUNT_DETAIL', data)
    },
    SetLanguageType: ({ commit }, type) => {
      commit('SET_LANGUAGE_TYPE', type)
    }
    // SetLoginDialog: ({ commit }, status) => {
    //   commit('SET_LOGIN_DIALOG', status)
    // }
  },
  mutations: {
    // 设置当前左侧菜单
    SET_CURRENT_MENU_OBJ: (state, menuObj) => {
      state.currentMenuObj = menuObj
      setStore({ name: 'currentMenuObj', content: state.currentMenuObj })
    },

    // 设置公司详情信息
    SET_COMPANY_DETAIL: async (state, data) => {
      state.companyDetail = data
    },
    // 设置企业账户详情信息
    SET_COMPANY_ACCOUNT_DETAIL: async (state, data) => {
      state.companyAccountDetail = data
    },
    // 设置个人账户详情信息
    SET_INDIVIDUAL_ACCOUNT_DETAIL: async (state, data) => {
      state.individualAccountDetail = data
    },
    // 设置展示语言类型
    SET_LANGUAGE_TYPE: async (state, type) => {
      state.langType = type
      localStorage.setItem('lang', type)
    },
    // 设置登录弹窗显隐
    SET_LOGIN_DIALOG: async (state, status) => {
      state.showLoginDialog = status
      localStorage.setItem('showLoginDialog', status)
    }
  }
}

export default common
